<div fxLayout="column" fxLayoutAlign="center center" class="text-center vh-100 mt-50 p-15">
  <!-- <div fxFlex="100" *ngIf="isQuickBooksEnabled === false; else isQuickBooksEnabledBlock">
    <h1 mat-dialog-title>Oh, oh… the service tier you currently have for QuickBooks Online does not <br /> support the synchronization of Products or Inventory Counts! </h1>
    <div mat-dialog-content class="mt-50">
      trakr Counting requires either the <strong>Plus</strong> or <strong>Advanced</strong> service tier of QuickBooks Online to connect.
    </div>
    <div mat-dialog-actions class="mt-90">
      <button mat-raised-button fxFlexAlign="center" color="secondary" (click)="onClose(false)">Return to trakr Counting</button>
    </div>
  </div> -->
  <div>
    <div fxFlex="100">
      <h1 mat-dialog-title>{{ "quickbooks.close_windows" | translate }}</h1>
      <div mat-dialog-content class="mt-50">
        {{ "quickbooks.start" | translate }}
      </div>
      <div mat-dialog-actions class="mt-90">
        <button mat-raised-button fxFlexAlign="center" color="primary" (click)="onClose(true)" [disabled]="isLoading">{{ "quickbooks.return" | translate }}</button>
      </div>
    </div>
  </div>
</div>